import React, {useEffect, useRef } from "react";
import "../styles/BinocularEyes.css";

const BinocularEyes = () => {
  const leftPupilRef = useRef(null);
  const rightPupilRef = useRef(null);

  const timeoutIdRef = useRef(null);

  // Function to make the eyes follow the mouse
  const followMouse = (e) => {
    const leftEye = leftPupilRef.current.parentElement;
    const rightEye = rightPupilRef.current.parentElement;

    const movePupil = (eye, pupil) => {
      const eyeRect = eye.getBoundingClientRect();
      const eyeCenterX = eyeRect.left + eyeRect.width / 2;
      const eyeCenterY = eyeRect.top + eyeRect.height / 2;

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      const angle = Math.atan2(mouseY - eyeCenterY, mouseX - eyeCenterX);
      const distance = Math.min(15, Math.hypot(mouseX - eyeCenterX, mouseY - eyeCenterY) / 10);

      pupil.style.transform = `translate(-50%, -50%) translate(${Math.cos(angle) * distance}px, ${Math.sin(angle) * distance}px)`;
    };

    movePupil(leftEye, leftPupilRef.current);
    movePupil(rightEye, rightPupilRef.current);
  };

  // Function to make the eyes blink
  const blinkEyes = () => {
    const eyes = [leftPupilRef.current.parentElement, rightPupilRef.current.parentElement];
    eyes.forEach((eye) => {
      eye.classList.add("blinking");
      setTimeout(() => eye.classList.remove("blinking"), 300);
    });

    // Randomize the blink interval
    timeoutIdRef.current = setTimeout(blinkEyes, Math.random() * 3000 + 2000);
  };

useEffect(() => {
    document.addEventListener("mousemove", followMouse);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousemove", followMouse);
    };
  }, []);

  useEffect(()=>{
    blinkEyes();
    return () => {
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
    }
  },);

  return (
    <div className="binocular-eyes">
      <div className="binocular-frame">
        <div className="eye left-eye">
          <div className="pupil" ref={leftPupilRef}></div>
          <div className="eyelid"></div> {/* Eyelid for the left eye */}
        </div>
      </div>
      <div className="binocular-connector"></div> {/* Connector between binoculars */}
      <div className="binocular-frame">
        <div className="eye right-eye">
          <div className="pupil" ref={rightPupilRef}></div>
          <div className="eyelid"></div> {/* Eyelid for the right eye */}
        </div>
      </div>
    </div>
  );
};

export default BinocularEyes;